import { Input } from '../ui/input';
import { Search } from 'lucide-react';

export const DocFilters = ({ q, setQ, cat, setCat, categories, counts }) => (
  <div className="space-y-3">
    <div className="relative max-w-md">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      <Input className="pl-9" placeholder="Doküman ara..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="doc-search-input" />
    </div>
    <div className="flex flex-wrap gap-2" data-testid="doc-category-filter">
      {[{ id: '', name: 'Tümü' }, ...categories].map(c => (
        <button key={c.id || 'all'} type="button" onClick={() => setCat(c.id)}
          className={`rounded-full border px-3 py-1 text-sm transition-colors ${cat === c.id ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-200 bg-white text-slate-600 hover:border-slate-400'}`}
          data-testid={`doc-cat-filter-${c.id || 'all'}`}>
          {c.name} <span className="opacity-60">{counts[c.id || 'all'] || 0}</span>
        </button>
      ))}
    </div>
  </div>
);

export const filterDocs = (docs, q, cat) => {
  const t = q.trim().toLocaleLowerCase('tr');
  return docs.filter(d => (!cat || d.category_id === cat) && (!t || `${d.title} ${d.name || d.versions?.at(-1)?.name || ''}`.toLocaleLowerCase('tr').includes(t)));
};

export const countByCat = (docs) => docs.reduce((acc, d) => ({ ...acc, [d.category_id]: (acc[d.category_id] || 0) + 1 }), { all: docs.length });
